import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

interface ExcludeTariffsConfig {
    quotas?: number[];
    variant: string;
}

type FeatureType = ExcludeTariffsConfig | undefined;

/** CLOUDWEB-19325: Не продавать дешёвые тарифы для оверквотеров */
export const excludeTariffsMobileOverquoters: FeatureType = IS_MOBILE_BROWSER && getFeature('exclude-tariffs-mobile-overquoters');

if (excludeTariffsMobileOverquoters) {
    registerExperiment(
        'exclude-for-overquoters',
        excludeTariffsMobileOverquoters?.variant,
        [
            AnalyticEventNames.TARIFFS_SHOWN,
            AnalyticEventNames.TARIFF_CLICK,
            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
            AnalyticEventNames.TARIFF_BUY,
        ],
        {
            sendXrayArgs: {
                TARIFFS_SHOWN: ({ isAlmostFullFreeUser } = {}) => ({ cancel: !isAlmostFullFreeUser }),
                TARIFF_CLICK: ({ isAlmostFullFreeUser }) => ({ cancel: !isAlmostFullFreeUser }),
                FAST_CHECKOUT_SHOWN: ({ isAlmostFullFreeUser }) => ({ cancel: !isAlmostFullFreeUser }),
                TARIFF_BUY: ({ isAlmostFullFreeUser }) => ({ cancel: !isAlmostFullFreeUser }),
            },
        }
    );
}
